/** Follower lists (Instagram and TikTok) are fetched at this size, the count the activity job asks for, cached under one key per account and sliced to the caller's limit. */
export const FOLLOWERS_FETCH_SIZE = 50

/** A follower limit as a whole number in 1..FOLLOWERS_FETCH_SIZE; a non-numeric or missing value falls back to 15. */
export function clampFollowersLimit(limit: unknown): number {
    const n = Math.floor(Number(limit))
    if (!Number.isFinite(n)) return 15
    return Math.min(Math.max(n, 1), FOLLOWERS_FETCH_SIZE)
}
